export default {
    phone: {
      mask: "+\\9\\98 (99) 999-99-99",
      autoUnmask: true,
      showMaskOnHover: false,
    }
  };
  